module.exports = __webpack_public_path__ + "4975f64f885e9e1e0ae1fafac8f0fd87.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/evaluation_report/assets/title_ielts.png
// module id = 795
// module chunks = 0